import Api from '../../../Api';
import { IPagedRequest } from '../../../shared-interfaces/IPagedRequest';
import { IPagedResponse } from '../../../shared-interfaces/IPagedResponse';
import IGroup from '../Interfaces/IGroup';

export interface IGetGroupsRequest {
  createdByUserId: string;
}

const GroupService = {
  getGroups: async (
    request: IPagedRequest<IGetGroupsRequest>,
  ): Promise<IPagedResponse<IGroup>> => {
    const response = await Api.get(
      `groups?page=${request.page}&pageSize=${request.pageSize}&createdByUserId=${request.searchParameters.createdByUserId}`,
    );
    return response.data as IPagedResponse<IGroup>;
  },
};
export default GroupService;
